import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy, CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { authInterceptorProviders } from './_helpers/auth.interceptor';
import { IconModule, IconSetModule, IconSetService } from '@coreui/icons-angular';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { ContestOnlineViewComponent } from './views/contestonline/contestonline-view.component';
import { ContestOnlineThiComponent } from './views/contestonline/contestonline-thi.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { FilterPipe } from './filter.pipe';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ToastrModule } from 'ngx-toastr';
import { AlertModule } from 'ngx-bootstrap/alert';
import { SafePipe } from './_safePipe/safePipe';
import { HuyPipe } from './_safePipe/huyPipe';
import { SearchPipe } from './_safePipe/searchPipe';
import { JwPaginationComponent } from 'jw-angular-pagination';
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    IconModule,
    IconSetModule.forRoot(),
    HttpClientModule,FormsModule,
    DateTimePickerModule,
    ModalModule.forRoot(),
    // EditorModule
    AngularEditorModule,
    PaginationModule.forRoot(),
    CKEditorModule,
    ToastrModule.forRoot(),
    AlertModule.forRoot(),
    ReactiveFormsModule,
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    RegisterComponent,
    ContestOnlineViewComponent,
    ContestOnlineThiComponent,
    FilterPipe,
    SafePipe,
    HuyPipe,
    SearchPipe,
    JwPaginationComponent
  ],
  providers: [
    // {
    //   provide: LocationStrategy,
    //   useClass: HashLocationStrategy
    // },
    IconSetService,
    authInterceptorProviders
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
